// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../../Common/Configurations/AuthContext";
// import Header from "../../../Common/Layout/Header";
// import BusOffers from "../../../Components/Advertisements/BusOffers";
// import SearchBusPanel1 from "../SearchBusPanel/SearchBusPanel1";
// import styles from "../SearchBus/SearchBus1.module.css";

// const SearchBus1 = ({ mode, onNavigate, templateId, branding }) => { 
//   const navigate = useNavigate();
//   const { user, loading } = useAuth();

//   const handleSearch = (searchQuery) => {
//     // 👇 Use the 3-mode logic
//     if (mode === "builder") {
//         onNavigate({ name: "bus-results", params: { searchQuery } });
//     } else if (mode === "preview") {
//         navigate(`/template-preview/${templateId}/bus-results`, { state: { searchQuery } });
//     } else {
//         navigate("/template/bus/results", { state: { searchQuery } });
//     }
//   };

//   if (loading) return <p>Loading...</p>;
//   if (!user) {
//     navigate("/");
//   }

//   return (
//     <div id="layout-wrapper">
    
//       {/* Hero Section with Background Image */}
//       <section className={styles.heroSection}>
//         <div className={styles.heroOverlay}>
//           <div className={styles.heroContent}>
//             <div className={styles.heroText}>
//               <h1 className={styles.heroTitle}>
//                 Travel Beyond <span className={styles.heroHighlight}>Expectations.</span>
//               </h1>
//               <p className={styles.heroSubtitle}>
//                 India's most tech-advanced bus network.
//               </p>
//             </div>

//             {/* Search Component Container */}
//             <div className={styles.searchContainer}>
//                <SearchBusPanel1 
//        onSearch={handleSearch} 
//        mode={mode} 
//        onNavigate={onNavigate} 
//        templateId={templateId} 
//     />
//             </div>

//             {/* Decorative Elements */}
//             <div className={styles.heroBadges}>
//               <div className={styles.badge}>
//                 <span className={styles.badgeIcon}>✓</span>
//                 98% On-Time
//               </div>
//               <div className={styles.badge}>
//                 <span className={styles.badgeIcon}>✓</span>
//                 500+ Buses
//               </div>
//               <div className={styles.badge}>
//                 <span className={styles.badgeIcon}>✓</span>
//                 Live Tracking
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Main Content */}
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             {/* Bus Offers Section */}
//             <BusOffers />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SearchBus1;

import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Common/Configurations/AuthContext";
import BusOffers from "../../../Components/Advertisements/BusOffers";
import SearchBusPanel1 from "../SearchBusPanel/SearchBusPanel1";
import styles from "./SearchBus1.module.css"; // Fixed import path

const SearchBus1 = ({ styleConfig, mode, onNavigate, templateId, branding }) => { 
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  // Dynamic Theme Variables
  const themeVariables = {
    "--primary-color": styleConfig?.primary || "#3b82f6",
    "--secondary-color": styleConfig?.secondary || "#8b5cf6",
  };

  const handleSearch = (searchQuery) => {
    if (mode === "builder") {
        onNavigate({ name: "bus-results", params: { searchQuery } });
    } else if (mode === "preview") {
        navigate(`/template-preview/${templateId}/bus-results`, { state: { searchQuery } });
    } else {
        navigate("/template/bus/results", { state: { searchQuery } });
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper" style={themeVariables}>
      <section className={styles.heroSection}>
        <div className={styles.heroOverlay}>
          <div className={styles.heroContent}>
            
            <div className={styles.heroText}>
              <h1 className={styles.heroTitle}>
                Travel Beyond <span className={styles.heroHighlight}>Expectations.</span>
              </h1>
              <p className={styles.heroSubtitle}>
                India's most tech-advanced bus network.
              </p>
            </div>

            <div className={styles.searchContainer}>
               <SearchBusPanel1 
                 styleConfig={styleConfig} // Pass styles down
                 onSearch={handleSearch} 
                 mode={mode} 
                 onNavigate={onNavigate} 
                 templateId={templateId} 
               />
            </div>

            <div className={styles.heroBadges}>
              <div className={styles.badge}><span className={styles.badgeIcon}>✓</span> 98% On-Time</div>
              <div className={styles.badge}><span className={styles.badgeIcon}>✓</span> 500+ Buses</div>
              <div className={styles.badge}><span className={styles.badgeIcon}>✓</span> Live Tracking</div>
            </div>

          </div>
        </div>
      </section>

      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <BusOffers />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBus1;